import React, { useState, useEffect } from 'react';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, FormText } from 'reactstrap';
import { isNumber, Translate, translate, ValidatedField, ValidatedForm } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { convertDateTimeFromServer, convertDateTimeToServer, displayDefaultDateTime } from 'app/shared/util/date-utils';
import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { IThongTinDiaPhuong } from 'app/shared/model/thong-tin-dia-phuong.model';
import { getEntity, updateEntity, createEntity, reset } from './thong-tin-dia-phuong.reducer';

export const ThongTinDiaPhuongUpdate = (props: RouteComponentProps<{ id: string }>) => {
  const dispatch = useAppDispatch();

  const [isNew] = useState(!props.match.params || !props.match.params.id);

  const thongTinDiaPhuongEntity = useAppSelector(state => state.thongTinDiaPhuong.entity);
  const loading = useAppSelector(state => state.thongTinDiaPhuong.loading);
  const updating = useAppSelector(state => state.thongTinDiaPhuong.updating);
  const updateSuccess = useAppSelector(state => state.thongTinDiaPhuong.updateSuccess);
  const handleClose = () => {
    props.history.push('/thong-tin-dia-phuong');
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(props.match.params.id));
    }
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    const entity = {
      ...thongTinDiaPhuongEntity,
      ...values,
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          ...thongTinDiaPhuongEntity,
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="xtdtApp.thongTinDiaPhuong.home.createOrEditLabel" data-cy="ThongTinDiaPhuongCreateUpdateHeading">
            <Translate contentKey="xtdtApp.thongTinDiaPhuong.home.createOrEditLabel">Create or edit a ThongTinDiaPhuong</Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="thong-tin-dia-phuong-id"
                  label={translate('global.field.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('xtdtApp.thongTinDiaPhuong.moTa')}
                id="thong-tin-dia-phuong-moTa"
                name="moTa"
                data-cy="moTa"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.thongTinDiaPhuong.dienTich')}
                id="thong-tin-dia-phuong-dienTich"
                name="dienTich"
                data-cy="dienTich"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.thongTinDiaPhuong.danSo')}
                id="thong-tin-dia-phuong-danSo"
                name="danSo"
                data-cy="danSo"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.thongTinDiaPhuong.soLaoDong')}
                id="thong-tin-dia-phuong-soLaoDong"
                name="soLaoDong"
                data-cy="soLaoDong"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.thongTinDiaPhuong.gRDP')}
                id="thong-tin-dia-phuong-gRDP"
                name="gRDP"
                data-cy="gRDP"
                type="text"
              />
              <ValidatedField
                label={translate('xtdtApp.thongTinDiaPhuong.gRDPNguoi')}
                id="thong-tin-dia-phuong-gRDPNguoi"
                name="gRDPNguoi"
                data-cy="gRDPNguoi"
                type="text"
              />
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/thong-tin-dia-phuong" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default ThongTinDiaPhuongUpdate;
